// src/pages/parametrizacao/CreateEditLojaAcessoSidePanelContent.tsx
import React from 'react';
import CloseButtonSidePanel from '../../components/common/CloseButtonSidePanel';
import SaveButton from '../../components/common/SaveButton';
import { Loja } from '../../types/parametrizacao/Loja';
import './CreateEditLojaAcessoSidePanelContent.css';
import { useAuth } from '../../contexts/AuthContext';

interface CreateEditLojaAcessoSidePanelContentProps {
  selectedLoja: Loja;
  isLoading: boolean;
  handleFormChange: (field: keyof Loja, value: string) => void;
  handleSave: () => void;
  handleCancel: () => void;
}

const CreateEditLojaAcessoSidePanelContent: React.FC<CreateEditLojaAcessoSidePanelContentProps> = ({
  selectedLoja,
  isLoading,
  handleFormChange,
  handleSave,
  handleCancel,
}) => {
  const { hasPermission, role } = useAuth();
  const InputStyleDisable = {
    backgroundColor: '#e74d3c2f',
    cursor: 'not-allowed',
  };

  return (
    <div className="form-content">
      <CloseButtonSidePanel onClick={handleCancel} className="close-button-absolute" disabled={isLoading}/>
      <div className="facelet-h3">
      <h3>
        {selectedLoja.id ? (
          <>Visualizando: Editar loja</>
        ) : (
          <>Visualizando: Integrar nova loja</>
        )}
      </h3>
      </div>
      <hr />
      <label>
        Código Filial (Integração):
        <input
          style={InputStyleDisable}
          type="text"
          value={selectedLoja.codFilial}
          disabled
        />
      </label>
      <label>
        Nome Fantasia:
        <input
          type="text"
          value={selectedLoja.nomeFantasia}
          onChange={(e) => handleFormChange('nomeFantasia', e.target.value)}
          disabled={!(role === 'ROLE_MASTER' || (selectedLoja.id ? hasPermission('lojas_acesso.editar') : hasPermission('lojas_acesso.cadastrar')))}
          style={!(role === 'ROLE_MASTER' || (selectedLoja.id ? hasPermission('lojas_acesso.editar') : hasPermission('lojas_acesso.cadastrar'))) ? InputStyleDisable : undefined}
        />
      </label>
      <label>
        CNPJ:
        <input
          style={InputStyleDisable}
          type="text"
          value={selectedLoja.cnpj}
          disabled
        />
      </label>
      <label>
        Razão Social:
        <input
          style={InputStyleDisable}
          type="text"
          value={selectedLoja.razaoSocial}
          disabled
        />
      </label>
        <div className="form-actions">
          {(role === 'ROLE_MASTER' || (selectedLoja.id ? hasPermission('lojas_acesso.editar') : hasPermission('lojas_acesso.cadastrar'))) && (
            <SaveButton
              isLoading={isLoading}
              onClick={handleSave}
            />
          )}
        </div>
    </div>
  );
};

export default CreateEditLojaAcessoSidePanelContent;